import { SST } from "@biz/definitions/SST";
import { SunSailType } from "@biz/definitions/SunSailDefinitions";
import { ISail2dAMCXBaseForm, ISail2dCSXSTwinBaseForm, ISail2dFixedForm, ISail2dForm, ISail2dSandy } from "@biz/models/Sail2dDefinitions";

interface ISSTForm {
  sunSailTypes: SunSailType | readonly SunSailType[];
  form: any;
}
export class SSTForm {
  static Sandy = { sunSailTypes: SST.Sandy, form: null as any as ISail2dSandy }
  static Fixed = { sunSailTypes: SST.F, form: null as any as ISail2dFixedForm }
  static CsXsTwin = { sunSailTypes: SST.CsXsTwin, form: null as any as ISail2dCSXSTwinBaseForm }
  static AMCXOneFlex = { sunSailTypes: [...SST.AMCX, SST.One, SST.Flex], form: null as any as ISail2dAMCXBaseForm }

  static is<T extends ISSTForm>(obj: ISail2dForm, form: T): obj is T["form"] {
    if (SST.is(obj.sunSailType, form.sunSailTypes))
      return true;
    return false;
  }
}